module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"availability_TRUE":"Verfügbare Messdaten","yLabels":{"amount":"Endenergie (MWh)","amount_normalized":"Endenergie witterungsbereinigt (MWh)","ee":"Endenergie (MWh)","s12e":"Scope 1-2 Emissionen (t)","s123e":"Scope 1-3 Emissionen (t)","per":"Primärenergie (erneuerbar) (MWh)"},"units":{"amount":"MWh","amount_normalized":"MWh","s12e":"t","s123e":"t","per":"MWh","ee":"MWh"}}}')
  delete Component.options._Ctor
}
